<template>
  <el-select v-model="curvalue"
             filterable
             placeholder="请选择"
             clearable
             @change="changeval">
    <el-option v-for="item in options"
               :key="item.value"
               :label="item.label"
               :value="item.label">
    </el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: 'platform/hospital/getHospitaList'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      options: [],
      curvalue: this.value
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        page: 1,
        pageNumber: 10000
      };
      this.axios.post(this.url, data).then((res) => {
        this.options = res.data.list.map((res) => {
          return {
            value: res.hospital_id,
            label: res.hospital_name
          };
        });
      });
    },
    changeval() {
      this.$emit('change', this.curvalue);
      this.$emit('update');
    },
    rest() {
      this.curvalue = '';
    }
  }
};
</script>
<style lang="scss" scoped></style>
